<template>
  <div class="side-box">
    <div :class="{ collapse: collapse }" class="logo-box">
      <a-image :src="companyLogo" lazy style="width: 35px; height: 35px; border-radius: 50%">
        <template #placeholder>
          <div class="image-slot"></div>
        </template>
      </a-image>
      <div v-show="!collapse" class="login-title">
        <div class="line-1 f-16">{{ companyName }}</div>
        <div class="f-12">ID：{{ companyId }}</div>
      </div>
    </div>
    <a-menu
      :inline-collapsed="collapse"
      :open-keys="openKeys"
      :selected-Keys="selectedKeys"
      :style="{ width: collapse ? 'auto' : '190px' }"
      class="menu"
      mode="inline"
      @click="handleRoute"
      @openChange="onOpenChange"
    >
      <template #overflowedIndicator>
        <span>
          <left-outlined />
        </span>
      </template>
      <a-sub-menu v-for="item in menuList" :key="item.id">
        <template #icon>
          <MyIcon :type="item.icon" style="font-size: 18px !important" />
        </template>
        <template #title> {{ item.title }}</template>
        <a-menu-item v-for="itemc in item.child" :key="itemc.url" @click="handclick(itemc)">
          <template v-if="itemc.icon" #icon>
            <MyIcon :type="itemc.icon" />
          </template>
          {{ itemc.title }}
        </a-menu-item>
      </a-sub-menu>
    </a-menu>
  </div>
</template>

<script>
import { computed, onMounted, ref } from 'vue';
import store from '@/store/pms/landlord/index';
import { createFromIconfontCN, LeftOutlined } from '@ant-design/icons-vue';
import router from '@/router/index';

const MyIcon = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_2843326_cmakqu2yovs.js',
});
export default {
  components: {
    LeftOutlined,
    MyIcon,
  },
  setup() {
    let companyLogo = ref();
    let companyName = ref();
    let companyId = ref();


    const collapse = computed(() => {
      return store.state.collapseSign;
    });

    let menuList = computed(() => {
      return store.getters.getSideRouter;
    });
    let openKeys = ref();

    function onOpenChange(value) {
      openKeys.value = value.slice(-1);
    }

    let selectedKeys = computed(() => {
      return [router.currentRoute.value.path];
    });

    function findOpenKey(value) {
      for (let item of menuList.value) {
        for (let itemc of item.child) {
          if (itemc.name == value) {
            openKeys.value = [item.id];
          }
        }
      }
    }

    // 路由跳转
    function handleRoute(array) {
      // 移除/pms前缀，避免生成多余的/pms路径
      let routePath = array.key.replace(/^\/pms/, '');
      router.push(`${routePath}`);
    }

    // 储存单页权限数据
    function handclick(item) {
      store.commit('saveLimitsData', item.child ? item.child : []);
    }

    onMounted(() => {
      findOpenKey(router.currentRoute.value.name);
      setTimeout(() => {
        const companyInfo = JSON.parse(sessionStorage.getItem('companyInfo'));
        companyLogo.value = companyInfo.logo;
        companyName.value = companyInfo.name;
        companyId.value = companyInfo.id;
      }, 200);
    });

    return {
      collapse,
      menuList,
      onOpenChange,
      openKeys,
      handleRoute,
      handclick,
      selectedKeys,
      companyLogo,
      companyName,
      companyId,
    };
  },
};
</script>

<style lang="scss" scoped>
.menu {
  height: calc(100% - 50px);
}

.side-box {
  height: 100%;
  overflow-y: scroll;
}

.side-box::-webkit-scrollbar {
  width: 0 !important;
}

.logo-box {
  height: 50px;
  // line-height: 50px;
  color: #fff;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  display: flex;
  align-items: center;
  padding-left: 10px;
  background-color: #ffffff;

  .login-title {
    margin-left: 15px;
    overflow: hidden;
    max-width: 100px;
    color: #303030;
  }
}

:deep(.ant-menu-submenu-arrow::before),
:deep(.ant-menu-submenu-arrow::after) {
  background-color: #999999 !important;
}
</style>
